import { YOUTUBE_CHANNEL_URL } from "../data/youtube";

const YOUTUBE_API_BASE_URL = "https://www.googleapis.com/youtube/v3";
const YOUTUBE_HANDLE = YOUTUBE_CHANNEL_URL.split("@")[1] || "srisodevadirajamatha";
const YOUTUBE_CANONICAL_COUNT = 8;
let latestYoutubeVideosPromise;

const fetchJson = async (url) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Request failed with ${response.status}`);
  }
  return response.json();
};

const loadLatestYoutubeVideos = async () => {
  const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY;
  if (!apiKey) {
    if (process.env.NODE_ENV !== "production") {
      console.warn("YouTube API key is missing. Set REACT_APP_YOUTUBE_API_KEY to load latest videos.");
    }
    return [];
  }

  const channelParams = new URLSearchParams({
    part: "contentDetails",
    forHandle: `@${YOUTUBE_HANDLE}`,
    key: apiKey,
  });

  const channelPayload = await fetchJson(`${YOUTUBE_API_BASE_URL}/channels?${channelParams.toString()}`);
  const uploadsPlaylistId = channelPayload?.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;

  if (!uploadsPlaylistId) {
    return [];
  }

  const playlistParams = new URLSearchParams({
    part: "snippet,contentDetails",
    playlistId: uploadsPlaylistId,
    maxResults: String(YOUTUBE_CANONICAL_COUNT),
    key: apiKey,
  });

  const playlistPayload = await fetchJson(`${YOUTUBE_API_BASE_URL}/playlistItems?${playlistParams.toString()}`);
  const playlistVideos = (playlistPayload?.items || [])
    .map((item) => ({
      id: item?.contentDetails?.videoId,
      title: item?.snippet?.title || "Sri Sode Vadiraja Matha",
      publishedAt: item?.contentDetails?.videoPublishedAt || item?.snippet?.publishedAt || "",
      duration: "",
    }))
    .filter((video) => !!video.id);

  if (playlistVideos.length === 0) {
    return [];
  }

  const videoDetailsParams = new URLSearchParams({
    part: "snippet",
    id: playlistVideos.map((video) => video.id).join(","),
    key: apiKey,
  });

  const videoDetailsPayload = await fetchJson(`${YOUTUBE_API_BASE_URL}/videos?${videoDetailsParams.toString()}`);
  const liveStatusById = (videoDetailsPayload?.items || []).reduce((acc, item) => {
    if (item?.id) {
      acc[item.id] = item?.snippet?.liveBroadcastContent === "live";
    }
    return acc;
  }, {});

  return playlistVideos.map((video) => ({
    ...video,
    isLive: !!liveStatusById[video.id],
  }));
};

export const fetchLatestYoutubeVideos = async ({ maxResults = 8 } = {}) => {
  if (!latestYoutubeVideosPromise) {
    latestYoutubeVideosPromise = loadLatestYoutubeVideos().catch((error) => {
      latestYoutubeVideosPromise = null;
      throw error;
    });
  }

  const videos = await latestYoutubeVideosPromise;
  return videos.slice(0, maxResults);
};

export const fetchYoutubeVideoTitles = async (videos = []) => {
  const results = await Promise.all(
    videos.map((video) =>
      fetch(`https://www.youtube.com/oembed?url=https%3A//www.youtube.com/watch?v=${video.id}&format=json`)
        .then((response) => (response.ok ? response.json() : null))
        .then((json) => (json ? [video.id, json.title] : null))
        .catch(() => null)
    )
  );

  return results.reduce((titles, result) => {
    if (result) {
      titles[result[0]] = result[1];
    }
    return titles;
  }, {});
};
